import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { FloatingTooltip } from '../../../Floating'
import { Link, LINK_BASIC } from '../../../Link'

function ProfileContactsWidgetListCellViewRowWrapper({
  children,
  className,
  floatingTooltip,
  link,
  target,
}) {
  const tooltip = (
    <FloatingTooltip
      content={floatingTooltip}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      {children}
    </FloatingTooltip>
  )

  return link ? (
    <Link className={className} target={target} to={link} variant={LINK_BASIC}>
      {tooltip}
    </Link>
  ) : (
    tooltip
  )
}

export default ProfileContactsWidgetListCellViewRowWrapper
